import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { Button } from './Button';
import { Seal } from '../brand/Seal';
interface CtaBandProps {
  title?: string;
  intro?: string;
}
export function CtaBand({
  title = 'More choice is better health for all.',
  intro = 'Start with the intake. Nothing is charged until a clinician has reviewed your labs and you have approved the protocol.'
}: CtaBandProps) {
  return <section className="bg-ink text-cream-light" data-id="element-250" data-mp="v3tuqodwnaju">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-24" data-id="element-251" data-mp="r16vw3itgpd5">
        <div className="grid items-center gap-12 lg:grid-cols-[1.3fr_auto] lg:gap-20" data-id="element-252" data-mp="qzvta713xnnm">
          <div data-id="element-253" data-mp="m2m50upgfi1d">
            <h2 className="max-w-2xl font-serif text-4xl leading-[1.06] md:text-[3.5rem]" data-id="element-254" data-mp="m46ptslyvmm1">
              {title}
            </h2>
            <p className="mt-6 max-w-lg text-base leading-relaxed text-cream/70" data-id="element-255" data-mp="2gfv8o5vbk9bp">{intro}</p>
            <div className="mt-10 flex flex-wrap items-center gap-4" data-id="element-256" data-mp="2bh0op0lm8eq0">
              <Button to="/get-started" data-id="element-257" data-mp="2bhtsbspa2o3x">
                Start your intake
                <ArrowRightIcon className="h-4 w-4" data-id="element-258" data-mp="2p5af4ggl2178" />
              </Button>
              <Button to="/pricing" variant="ghost" data-id="element-259" data-mp="2t7x9op4n2084">
                See pricing
              </Button>
            </div>
          </div>
          <Seal className="hidden h-40 w-40 text-cream/45 lg:block" data-id="element-260" data-mp="2f9gvye8cz9gh" />
        </div>
      </div>
    </section>;
}